export const handelOpenModalSelectBaseMarket = (origin) => ({
    type: 'OPEN_MODAL_SELECT_BASE_MARKET',origin
});
export const handelCloseModalSelectBaseMarket = () => ({
    type: 'CLOSE_MODAL_SELECT_BASE_MARKET'
});